// I18N — initializes i18next with HTTP backend, language detector, and RTL handling.
// Loads translations from /locales/{{lng}}/{{ns}}.json at runtime.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const SUPPORTED_LANGUAGES = ["en", "ar", "so"];
export const RTL_LANGUAGES = ["ar"];
export const DEFAULT_LANGUAGE = "en";

const applyDirection = (lng) => {
  if (typeof document === "undefined") return;
  const lang = (lng || DEFAULT_LANGUAGE).split("-")[0];
  const isRtl = RTL_LANGUAGES.includes(lang);
  document.documentElement.dir = isRtl ? "rtl" : "ltr";
  document.documentElement.lang = lang;
  document.body && document.body.classList.toggle("rtl", isRtl);
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    ns: ["common"],
    defaultNS: "common",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "sokaab_lang",
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

i18n.on("languageChanged", applyDirection);
applyDirection(i18n.language || DEFAULT_LANGUAGE);

export default i18n;
